import { Spinner } from "@capacit-com/lara-law-shared-ui";
const LoadingOverlay = ({ text }: { text: string }) => (
  <div className="absolute inset-0 z-10 items-center justify-center bg-background/60 backdrop-blur-[2.5px] rounded-sm">
    <div className="flex justify-center h-full items-center gap-2">
      <Spinner className="size-5" />
      <p className="text-accent-foreground text-sm">{text}</p>
    </div>
  </div>
);

export default LoadingOverlay;
